export default __webpack_public_path__ + "static/media/chat.54c513a5.svg";